import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/auth-context';
import {
  WelcomeHeader,
  SetupProgress,
  HowItWorksFlow,
  QuickTipCard,
  QuickActionsBar,
  ADMIN_TIPS,
} from '@/components/tips';

export default function AdminTipsPage() {
  const { t } = useTranslation('tips');
  const { user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <WelcomeHeader userName={user?.firstName || 'Admin'} />
      <SetupProgress />
      <HowItWorksFlow />
      <section>
        <h2 className="text-h3 text-ink mb-4">
          {t('quickTips.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {ADMIN_TIPS.map((tip) => (
            <QuickTipCard
              key={tip.id}
              icon={tip.icon}
              title={t(tip.titleKey)}
              description={t(tip.descriptionKey)}
              tips={tip.tipsKeys.map((key) => t(key))}
              color={tip.color}
              actionLabel={tip.actionLabelKey ? t(tip.actionLabelKey) : undefined}
              actionPath={tip.actionPath}
            />
          ))}
        </div>
      </section>
      <QuickActionsBar />
    </div>
  );
}
